import { parse, format } from "date-fns"

const updatedAt = query => {
  const date = parse(query.file.modifiedTime)
  return format(date, "MMMM YYYY")
}

export default updatedAt
